import { Action, createReducer, on } from '@ngrx/store';
import { PaymentMandateRequest, PaymentMandateResponse } from '../models/payment-mandate.model';
import * as fromPaymentMandateActions from '../actions';

export const generatePaymentMandateFeatureKey = 'generatePaymentMandate';

export interface GeneratePaymentMandateState {
  loadGeneratePaymentMandateRequest: PaymentMandateRequest;
  loadGeneratePaymentMandateSuccess: PaymentMandateResponse;
  loadGeneratePaymentMandateFailure: Error | any;
  isLoaded: boolean;
  paymentMandateAccepted: boolean;
  saveCard: PaymentMandateRequest;
}

export const initialState: GeneratePaymentMandateState = {
  loadGeneratePaymentMandateRequest: undefined,
  loadGeneratePaymentMandateSuccess: undefined,
  loadGeneratePaymentMandateFailure: undefined,
  isLoaded: false,
  paymentMandateAccepted: false,
  saveCard: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromPaymentMandateActions.loadGeneratePaymentMandates, (state, action) => ({
    ...state,
    loadGeneratePaymentMandateRequest: action.request.body
  })),
  on(fromPaymentMandateActions.loadGeneratePaymentMandatesSuccess, (state, action) => ({
    ...state,
    loadGeneratePaymentMandateSuccess: action.response,
    isLoaded: true
  })),
  on(fromPaymentMandateActions.loadGeneratePaymentMandatesFailure, (state, action) => ({
    ...state,
    loadGeneratePaymentMandateFailure: action.error,
    isLoaded: false
  })),
  on(fromPaymentMandateActions.clearGeneratePaymentMandatesSuccess, (state, action) => ({
    ...state,
    loadGeneratePaymentMandateSuccess: undefined,
    isLoaded: false
  })),

  // Payment Mandate Accepted
  on(fromPaymentMandateActions.paymentMandateAccepted, (state, action) => ({
    ...state,
    paymentMandateAccepted: action.accepted
  })),

  //save card details
  on(fromPaymentMandateActions.saveAddCreditCards, (state, action) => ({
    ...state,
    saveCard: action.saveCard
  }))
);

export const getGeneratedPaymentMandateRequest = (state: GeneratePaymentMandateState) => state.loadGeneratePaymentMandateRequest;
export const getGeneratedPaymentMandateResponse = (state: GeneratePaymentMandateState) => state.loadGeneratePaymentMandateSuccess;
export const getGeneratedPaymentMandateFailure = (state: GeneratePaymentMandateState) => state.loadGeneratePaymentMandateFailure;
export const getGeneratedPaymentMandateIsLoaded = (state: GeneratePaymentMandateState) => state.isLoaded;

//Payment Mandate Accepted
export const getIsPaymentMandateAccepted = (state: GeneratePaymentMandateState) => state.paymentMandateAccepted;

//get card details
export const getSaveCard = (state: GeneratePaymentMandateState) => state.saveCard;
